import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { AccountHook } from '../account-hooks.types';
import { AccountHooksService } from '../account-hooks.service';
import { AddAccountHookComponent } from 'app/modules/settings/account-hooks/add-account-hook/add-account-hook.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Store } from '@ngxs/store';
import { UserState } from '@state/user/state';

@Component({
  selector: 'account-hooks-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountHooksListComponent implements OnInit, OnDestroy {
  accountHooks: AccountHook[];
  mailsLoading: boolean;
  pagination: any;
  selectedAccountHook: AccountHook;

  @ViewChild('mailList')
  mailList: ElementRef;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MailboxComponent} mailboxComponent
   */
  constructor(
    private _matDialog: MatDialog,
    private _accountHooksService: AccountHooksService,
    private store: Store,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.mailsLoading = false;
  }

  get isActionEnabled(): boolean {
    const user = this.store.selectSnapshot(UserState.getUser);
    return user?.email?.includes('@termsheet.com');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Mails
    this._accountHooksService.accountHooks$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((accountHooks: AccountHook[]) => {
        this.accountHooks = accountHooks;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * On mail selected
   *
   * @param mail
   */
  onAccountHookSelected(accountHook: AccountHook): void {
    // Execute the mailSelected observable
    this._accountHooksService.selectedAccountHookChanged.next(accountHook);
    this.selectedAccountHook = accountHook;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  addAccountFunction() {
    // Open the dialog
    const dialogRef = this._matDialog.open(AddAccountHookComponent, {
      panelClass: 'mailbox-compose-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
